module.exports = __webpack_public_path__ + "static/media/Consultant2xs.9ecd045d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeOperation/Consultant2xs.png
// module id = 529
// module chunks = 0